import { item } from './employee_register_data';

export const employee_drawers_a = {
  'E-204': {
    section: 'Employee - E-204 - Finance',
    name: 'Sarah Khumalo',
    subtitle: 'Junior Analyst - Finance - joined Feb 2026',
    status: 'Action required',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    callout: 'Originated in OnboardOS. Employee journey: Complyon monitors ongoing obligations and can re-trigger onboarding when items lapse.',
    score: 27,
    score_tone: 'is-red',
    joined: '2026',
    fit_proper: 'Required',
    open_items: '8',
    chip_groups: [
      ['Procurement policy', 'Delegation of authority', 'Fit & proper check'],
      ['Procurement ethics training']
    ],
    primary_items: [
      item('DoA: Off 03 - Junior Analyst', 'Approved spend routed by Delegation of Authority engine', 'review'),
      item('Capture quotations', 'Approver threshold: R250 000', 'pending'),
      item('Delegation fallback and annual attestations', 'Linked to role permissions')
    ],
    sections: [
      {
        title: 'Policy acknowledgements & declarations',
        items: [
          item('Code of conduct', 'Signed 04 Feb 2026', 'accepted', 'success'),
          item('POPIA / data protection', 'Due 30 Jun 2026', 'outstanding', 'warning'),
          item('Procurement policy', 'Due 30 Jun 2026', 'outstanding', 'warning')
        ]
      },
      {
        title: 'Training status',
        items: [
          item('Cybersecurity awareness', 'Due 17 May 2026', 'outstanding', 'warning'),
          item('POPIA awareness', 'Due 30 Jun 2026', 'outstanding', 'warning'),
          item('Code of conduct', 'Completed', 'complete', 'success')
        ]
      },
      {
        title: 'Conflict & declaration status',
        items: [
          item('Annual declaration not yet submitted', 'Annual conflict-of-interest attestation', 'outstanding', 'warning')
        ]
      },
      {
        title: 'Access & approvals',
        items: [
          item('Finance ERP - Standard', 'Last review 02 Mar 2026', 'review', 'warning'),
          item('Email & docs - Standard', 'Last review 27 Jan 2026', 'current', 'success'),
          item('Laptop IT-027', 'Asset check current', 'assigned', 'success')
        ]
      },
      {
        title: 'Exit / exceptions & controls',
        items: [
          item('System access revoked at offboarding', 'Pending', 'pending', 'danger'),
          item('Assigned assets returned & signed off', 'Pending', 'pending', 'danger'),
          item('Final conflict & confidentiality declaration', 'Pending', 'pending', 'danger'),
          item('Knowledge handover completed', 'Pending', 'pending', 'danger'),
          item('Final pay cleared & PO-file access review applied', 'Pending', 'pending', 'danger')
        ]
      }
    ],
    alerts: [
      'Annual re-onboarding / compliance review required: open policy and training items, declared and undelivered.'
    ],
    records: [
      item('DoA Off-03 - Finance approver set', '', 'assigned', 'neutral'),
      item('IT asset - laptop', '', 'assigned', 'neutral'),
      item('J12 complete', '', 'download', 'neutral'),
      item('Onboarding', '', 'download', 'neutral'),
      item('Acknowledgements & certificate', '', 'open', 'neutral')
    ],
    recommended_action: 'Send Sarah the overdue POPIA and procurement-policy tasks, then trigger the annual declaration flow before quarter-close approvals are assigned.'
  },
  'E-101': {
    section: 'Employee - E-101 - Finance',
    name: 'John Moyo',
    subtitle: 'Finance Manager - Finance - joined Mar 2021',
    status: 'Compliant',
    status_class: 'bg-success-subtle text-success-emphasis',
    callout: 'Active employee under Complyon monitoring. Overdue obligations can still re-trigger revalidation in OnboardOS.',
    score: 100,
    score_tone: 'is-green',
    joined: '2024',
    fit_proper: 'Required',
    open_items: '0',
    chip_groups: [
      ['Procurement policy', 'Delegation of authority', 'Fit & proper check'],
      ['Procurement ethics training']
    ],
    primary_items: [
      item('DoA: Off 01 - Finance Approver', 'Approved spend routed by Delegation of Authority engine', 'approved', 'success'),
      item('Approve payments <= R500 000', 'Authorised payments - R 500 000', 'current', 'success'),
      item('Finance supplier approvals', 'Back-up approver')
    ],
    sections: [
      {
        title: 'Policy acknowledgements & declarations',
        items: [
          item('Code of conduct', 'Signed 09 Feb 2026', 'accepted', 'success'),
          item('POPIA / data protection', 'Valid until next review', 'accepted', 'success'),
          item('Procurement policy', 'Valid until next review', 'accepted', 'success'),
          item('Delegation of authority', 'Valid until next review', 'accepted', 'success')
        ]
      },
      {
        title: 'Training status',
        items: [
          item('Procurement ethics', 'Completed', 'complete', 'success'),
          item('POPIA awareness', 'Completed', 'complete', 'success'),
          item('Cybersecurity awareness', 'Completed', 'complete', 'success')
        ]
      },
      {
        title: 'Conflict & declaration status',
        items: [
          item('No conflicts declared - 11 Jan 2026', 'Declared: no interests requiring management action', 'current', 'success')
        ]
      },
      {
        title: 'Access & approvals',
        items: [
          item('Finance ERP - Approver', 'Last review 10 May 2026', 'current', 'success'),
          item('Payments - Authoriser', 'Last review 10 May 2026', 'current', 'success'),
          item('Laptop IT-028', 'Asset check current', 'assigned', 'success')
        ]
      },
      {
        title: 'Exit / exceptions & controls',
        items: [
          item('System access revoked at offboarding', 'Pending', 'pending', 'danger'),
          item('Assigned assets returned & signed off', 'Pending', 'pending', 'danger'),
          item('Final conflict & confidentiality declaration', 'Pending', 'pending', 'danger'),
          item('Knowledge handover completed', 'Pending', 'pending', 'danger'),
          item('Final pay cleared & PO-file access review applied', 'Pending', 'pending', 'danger')
        ]
      }
    ],
    alerts: [],
    records: [
      item('DoA Off-01 Finance approver set', '', 'assigned', 'neutral'),
      item('A1 signed', '', 'open', 'neutral'),
      item('J12 complete', '', 'download', 'neutral'),
      item('Onboarding', '', 'download', 'neutral'),
      item('Acknowledgements & certificate', '', 'open', 'neutral')
    ],
    recommended_action: 'No action required. Keep John in the quarterly finance-access review cycle.'
  },
  'E-156': {
    section: 'Employee - E-156 - Operations',
    name: 'Aisha Naidoo',
    subtitle: 'Operations Lead - Operations - joined Aug 2023',
    status: 'Action required',
    status_class: 'bg-warning-subtle text-warning-emphasis',
    callout: 'Active employee under Complyon monitoring. Overdue obligations can still re-trigger revalidation in OnboardOS.',
    score: 75,
    score_tone: 'is-orange',
    joined: '2024',
    fit_proper: 'N/A',
    open_items: '0',
    chip_groups: [
      ['Information security policy', 'Asset acknowledgement'],
      ['DoA: Off 03 - Operations'],
      ['Approve operational spend <= R120 000', 'Sign-off low-risk vendors']
    ],
    primary_items: [
      item('DoA: Off 03 - Operations', 'Approved spend routed by Delegation of Authority engine', 'approved', 'success')
    ],
    sections: [
      {
        title: 'Policy acknowledgements & declarations',
        items: [
          item('Code of conduct', 'Signed 17 Feb 2026', 'accepted', 'success'),
          item('POPIA / data protection', 'Valid until next review', 'accepted', 'success'),
          item('Information security', 'Due 17 May 2026', 'outstanding', 'warning')
        ]
      },
      {
        title: 'Training status',
        items: [
          item('Cybersecurity awareness', 'Completed', 'complete', 'success'),
          item('POPIA awareness', 'Completed', 'complete', 'success')
        ]
      },
      {
        title: 'Conflict & declaration status',
        items: [
          item('No conflicts - 03 Jan 2026', 'Declared: no conflicts requiring intervention', 'current', 'success')
        ]
      },
      {
        title: 'Access & approvals',
        items: [
          item('Operations portal - Admin', 'Last review 12 Mar 2026', 'review', 'warning'),
          item('Asset: Laptop with received after-device refresh', 'Tag OPS-129 received', 'new', 'neutral')
        ]
      },
      {
        title: 'Exit / exceptions & controls',
        items: [
          item('Thabo Mile SI-04 / access uplift confirmed', 'Pending', 'pending', 'danger'),
          item('Laptop IT-029', 'Asset check current', 'issued', 'danger')
        ]
      }
    ],
    alerts: [
      'Operations portal remains admin-level. Annual access re-attestation should be completed before Q3.'
    ],
    records: [
      item('DoA Off-03 Operations', '', 'assigned', 'neutral'),
      item('A2 signed', '', 'open', 'neutral'),
      item('J12 complete', '', 'download', 'neutral'),
      item('Onboarding', '', 'download', 'neutral'),
      item('Acknowledgements & certificate', '', 'open', 'neutral')
    ],
    recommended_action: 'Capture the information-security acknowledgement and complete the operations-portal access review before the next monthly operations cycle.'
  },
  'E-088': {
    section: 'Employee - E-088 - Procurement',
    name: 'Thabo Nkosi',
    subtitle: 'Procurement Officer - Procurement - joined Nov 2023',
    status: 'Compliant',
    status_class: 'bg-success-subtle text-success-emphasis',
    callout: 'Active employee under Complyon monitoring. Overdue obligations can still re-trigger revalidation in OnboardOS.',
    score: 100,
    score_tone: 'is-green',
    joined: '2024',
    fit_proper: 'Required',
    open_items: '0',
    chip_groups: [
      ['Procurement policy', 'Conflict of interest', 'Fit & proper check'],
      ['Procurement ethics training']
    ],
    primary_items: [
      item('DoA: Off 02 - Bid buyer', 'Approved spend routed by Delegation of Authority engine', 'approved', 'success'),
      item('New-vendor activate', 'Procurement ERP', 'ready', 'success')
    ],
    sections: [
      {
        title: 'Policy acknowledgements & declarations',
        items: [
          item('Code of conduct', 'Signed 02 Feb 2026', 'accepted', 'success'),
          item('Procurement policy', 'Signed 02 Feb 2026', 'accepted', 'success'),
          item('Conflict of interest', 'Completed', 'complete', 'success')
        ]
      },
      {
        title: 'Training status',
        items: [
          item('Procurement ethics', 'Completed', 'complete', 'success'),
          item('Conflict of interest', 'Completed', 'complete', 'success')
        ]
      },
      {
        title: 'Conflict & declaration status',
        items: [
          item('Declared interest in family business - annual logged', 'Reviewed and accepted', 'current', 'success')
        ]
      },
      {
        title: 'Access & approvals',
        items: [
          item('Procurement system - Buyer', 'Last review 11 Mar 2026', 'current', 'success'),
          item('Laptop IT-026', 'Asset check current', 'assigned', 'success')
        ]
      },
      {
        title: 'Exit / exceptions & controls',
        items: [
          item('System access revoked at offboarding', 'Pending', 'pending', 'danger'),
          item('Assigned assets returned & signed off', 'Pending', 'pending', 'danger'),
          item('Final conflict & confidentiality declaration', 'Pending', 'pending', 'danger'),
          item('Knowledge handover completed', 'Pending', 'pending', 'danger'),
          item('Final pay cleared & PO-file access review applied', 'Pending', 'pending', 'danger')
        ]
      }
    ],
    alerts: [],
    records: [
      item('DoA Off-02 - Bid buyer', '', 'assigned', 'neutral'),
      item('A1 signed', '', 'open', 'neutral'),
      item('J12 complete', '', 'download', 'neutral'),
      item('Onboarding', '', 'download', 'neutral'),
      item('Acknowledgements & certificate', '', 'open', 'neutral')
    ],
    recommended_action: 'Thabo is current. Keep the family-interest declaration attached to the procurement annual-review pack.'
  }
};
